<template>
    <el-menu class="left-sidebar-menu" @select="handleSelect" :default-active="$route.path">
        <el-menu-item index="/abroad/account/companyInfo">
            <i class="el-icon-suitcase"></i>
            <span slot="title">{{ $t("title.companyInfo")}}</span>
        </el-menu-item>
        <el-menu-item v-if="isMain" index="/abroad/account/subAccount">
            <i class="el-icon-user"></i>
            <span slot="title">{{ $t("subAccount.menu.subAccount")}}</span>
        </el-menu-item>
  </el-menu>
</template>
<script>
    import perm from '@/utils/permission'
    export default {
        computed: {
            isMain() {
                return !perm.isLoaded() || perm.isMain()
            },
        },
        created() {
            perm.load().catch(() => {})
        },
        methods: {
           handleSelect(key) {
                return this.$router.push(key)
           },
        }
    }
</script>
